import { Component,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { UserQuery } from './services/user/user.query';
import {requestsService} from './services/requests/requests.service'
import { ReportsdetailsService } from './services/reportsdetails.service';
import { CookieService } from 'ngx-cookie';
import { of } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit{
  title = 'oneCG';
  userData:any
  private readonly adminPanelRoute = '/home/admin-pannel/select-query-run';
  constructor(private router: Router,
    private user: UserQuery,private apiService: requestsService,private propService:ReportsdetailsService,private userQuery: UserQuery,private cookie:CookieService) {
  }


  ngOnInit(): void {
    this.registerLogoutListener();
    this.userQuery.syncRegionFromUrl();
       const userToken = this.user.getToken();
    let url=window.location.href
             const fragment = url.split('#')[2];
             const fragmentParams = new URLSearchParams(fragment);
              const idToken =  fragmentParams.get('id_token');
     if(fragmentParams.get('id_token')!=null){
                if(window.location.href.search("access_token") && window.location.href.search("access_token")!=-1){ 
                    // this.propService.EmailLink="https://onecg-preprod-samlintegration.d3bijszcmlj4kq.amplifyapp.com/"
                    var token= idToken;
                    var region=this.userQuery.syncRegionFromUrl(url);
                    if(token){
                        this.userQuery.setSamlUser("SamlUser")
                    }
                    if(region){
                      this.userQuery.setRegion = region;
                    }
                    var base64Url = token.split('.')[1];
                    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    var jsonPayload:any = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    }).join(''));
                   var tokenpayload =JSON.parse(jsonPayload);
                    const userdate={
                        "name":tokenpayload.name,
                        "middle_name":tokenpayload.middle_name,
                        // "phone_number":tokenpayload.phone_number,
                        "sub":tokenpayload.sub,
                        "email":tokenpayload.email
                    }
                    this.userQuery.setUser(userdate);
                    this.userQuery.setToken(token)
                    this.apiService.AWSUserDetails().subscribe(s=>{
                      this.userData=s
                        this.navigatePostSamlLogin('/home');
                        return of(true);

                      // if(this.userData.firstCorporateLogin==true){
                      //   localStorage.removeItem("UserCred");
                      //   this.cookie.remove("startDate")
                      //   this.cookie.remove("endDate");
                      //   localStorage.removeItem("tabBrowserService");
                      //   localStorage.removeItem("tabBrowser")
                      //   this.userQuery.logout();
                      //   return of(false);
                      // }else{
                      // }
                    });
                }
             }
   // main.setup();
  }

  private navigatePostSamlLogin(defaultRoute: string): void {
    this.apiService.isPlatFormAdmin().subscribe((res: any) => {
      if (this.isPlatformAdmin(res)) {
        this.apiService.oneCgBuildVersion().subscribe((buildRes: any) => {
          localStorage.setItem('qtBuildVersion', JSON.stringify(buildRes));
        });
        this.router.navigateByUrl(this.adminPanelRoute);
      } else {
        this.router.navigateByUrl(defaultRoute);
      }
    }, () => {
      this.router.navigateByUrl(defaultRoute);
    });
  }

  private isPlatformAdmin(res: any): boolean {
    if (typeof res === 'boolean') {
      return res;
    }
    if (res && typeof res === 'object') {
      return !!(res.isPlatFormAdmin || res.isPlatformAdmin || res.data);
    }
    return false;
  }

  private registerLogoutListener() {
    if (typeof window === 'undefined') {
      return;
    }

    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'onecg_logout') {
        this.userQuery.logout(false);
      }
    });

    if (typeof BroadcastChannel !== 'undefined') {
      const channel = new BroadcastChannel('onecg_logout');
      channel.onmessage = () => {
        this.userQuery.logout(false);
      };
    }
  }
  
  doUnload() {
    // Clear session or do something
   // this.auth.getLogout();
}

}
